import React, { useState, useEffect, useRef } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CFormInput,
  CForm
} from '@coreui/react'
import { useSnackbar } from 'notistack'
import { Profile as ProfileAPI, getSetting } from '../../API/admin'
import { WaitlistPlayersAPI, getPlayerSportsLatest } from '../../API/player'
import { UpdateProfile, UserExist } from '../../API/auth' // Make sure to import your API services
import Swal from 'sweetalert2'
// Modal
import ChangePassword from './ChangePassword'
import Withdrwal from '../modal/Withdrawal'

const Profileupdate = ({ user_details }) => {
  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE
  const [Photovisible, setPhotovisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const [profileImage, setProfileImage] = useState(
    user_details.profile_image != null &&
      user_details.profile_image.trim() !== ''
      ? IMAGE_URL + 'user/' + user_details.profile_image
      : IMAGE_URL + 'blank_user.png'
  )
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [selectedImage, setSelectedImage] = useState(null) // Keep track of selected image
  const fileInputRef = useRef(null)
  const [disableButton, setDisableButton] = useState(true)

  const [user, setUser] = useState([])
  const [isparticipant, setIsparticipant] = useState(false)
  const [withdrawal, setwithdrwal] = useState(false)
  const [waitingPlayer, setWaitingPlayer] = useState(false)
  const [Sports, setSports] = useState([])
  const [Zindex, setZindex] = useState(false)

  const [IsOn, setIsOn] = useState(null)

  const [formData, setFormData] = useState({
    id: user_details.id,
    fname: user_details.fname,
    lname: user_details.lname,
    profile_image: user_details.profile_image,
    corporate_email: user_details.corporate_email,
    username: user_details.username
  })

  const [formErrors, setFormErrors] = useState({})
  const [usernameError, setUsernameError] = useState('')

  const handleImageClick = () => {
    fileInputRef.current.click()
  }

  const handleImageChange = event => {
    const file = event.target.files[0]
    if (file) {
      const validImageTypes = [
        'image/jpeg',
        'image/png',
        'image/jpg',
        'image/webp'
      ]
      let validSubmit = false

      // Generate imgae previews

      if (!validImageTypes.includes(file.type)) {
        Swal.fire({
          title: 'Image format not supoorted',
          text: 'You can only upload image of following format. webp, jpg, png, jpeg',
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        event.target.value = '' // Clear the file input
        return
      } else {
        validSubmit = true
      }
      if (validSubmit) {
        const reader = new FileReader()
        reader.onloadend = () => {
          setProfileImage(reader.result) // Set preview image
        }
        reader.readAsDataURL(file)
        setSelectedImage(file) // Store selected image to send in the request
        setDisableButton(false) // Enable save button
      }
    }
  }

  const validateForm = () => {
    let errors = {}
    if (!formData.fname.trim()) {
      errors.fname = 'First name is required.'
    }
    if (!formData.lname.trim()) {
      errors.lname = 'Last name is required.'
    }
    if (!formData.username.trim()) {
      errors.username = 'Username is required.'
    }

    setFormErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validateForm()) {
      enqueueSnackbar('Please fill out the required fields', {
        variant: 'error',
        action: key => (
          <button
            className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key)
            }}
          >
            X
          </button>
        )
      })
      return
    }

    // Create FormData to handle the image upload and other form data
    const data = new FormData()
    data.append('id', formData.id)
    data.append('fname', formData.fname)
    data.append('lname', formData.lname)
    data.append('username', formData.username)
    data.append('corporate_email', formData.corporate_email)
    if (selectedImage != null) {
      data.append('profile_image', selectedImage) // Append image file if selected
    } else {
      data.append('profile_image', formData.profile_image) // Append existing image if no new image selected
    }
    if (user_details.username === formData.username) {
      const res = await UpdateProfile(data) // Assuming this is your API method for updating profiles
      if (res.data.status) {
        enqueueSnackbar('Profile updated successfully', {
          variant: 'success',
          action: key => (
            <button
              className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key)
              }}
            >
              X
            </button>
          )
        })
        setVisible(false)
        window.location.reload()
      } else {
        enqueueSnackbar(res.data.message, {
          variant: 'error',
          action: key => (
            <button
              className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key)
              }}
            >
              X
            </button>
          )
        })
      }
    } else {
      const res = await UserExist(formData.username, 'username', formData.id)
      if (res.username == 0) {
        setUsernameError(
          'Username already exists. Please choose a different one.'
        )
      } else {
        setUsernameError('')
        const res = await UpdateProfile(data)
        if (res.status) {
          enqueueSnackbar('Profile updated successfully', {
            variant: 'success',
            action: key => (
              <button
                className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key)
                }}
              >
                X
              </button>
            )
          })
          setVisible(false)
          window.location.reload()
        } else {
          enqueueSnackbar(res.data.message, {
            variant: 'error',
            action: key => (
              <button
                className='toast_close_btn'
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key)
                }}
              >
                X
              </button>
            )
          })
        }
      }
    }
    // Check if username exists before proceeding
  }

  const handleChange = e => {
    setDisableButton(false)
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  useEffect(() => {
    setFormData({
      fname: user_details.fname,
      lname: user_details.lname,
      email: user_details.email,
      profile_image: user_details.profile_image,
      corporate_email: user_details.corporate_email,
      username: user_details.username,
      id: user_details.id
    })
    const imageUrl =
      user_details.profile_image && user_details.profile_image.trim() !== ''
        ? IMAGE_URL + 'user/' + user_details.profile_image
        : IMAGE_URL + 'blank_user.png'

    setProfileImage(imageUrl)
  }, [user_details, IMAGE_URL])

  const handleRemoveModal = async () => {
    const updatedProfileImage = 'blank_user.png' // URL of the default image

    // Update formData with the new profile image
    setFormData(prevState => ({
      ...prevState,
      profile_image: updatedProfileImage
    }))

    // Call the API to update the profile with the default image
    const data = new FormData()
    data.append('id', formData.id)
    // data.append('fname', formData.fname);
    // data.append('lname', formData.lname);
    // data.append('username', formData.username);
    // data.append('corporate_email', formData.corporate_email);
    data.append('profile_image', updatedProfileImage)

    const res = await UpdateProfile(data)
    if (res.data.status) {
      enqueueSnackbar('Profile photo removed successfully', {
        variant: 'success',
        action: key => (
          <button
            className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key)
            }}
          >
            X
          </button>
        )
      })
      setPhotovisible(false) // Close the remove modal
      setVisible(false) // Optionally close the edit modal if you want
      window.location.reload()
    } else {
      enqueueSnackbar(res.data.message, {
        variant: 'error',
        action: key => (
          <button
            className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key)
            }}
          >
            X
          </button>
        )
      })
    }
  }

  //  eidt profile btn color handling acordingly user role
  let profile_btn_color
  if (user_details) {
    switch (user_details.role) {
      case 'participant':
        profile_btn_color = '#B2022F'
        break
      case 'admin':
        profile_btn_color = 'rgb(88 86 214)'
        break
      case 'scorer':
        profile_btn_color = '#B2022F'
        break
      default:
        profile_btn_color = ''
        break
    }
  } else {
    profile_btn_color = ''
  }
  console.log(user_details.role)

  //  BELOW CODE MANAGE THE WITHDRAWL AND CHANGE PASSWORD
  useEffect(() => {
    callAPI()
    callAPI2()
    callAPI3()
    callAPI4()
  }, [])

  let callAPI = async () => {
    let res = await ProfileAPI()
    if (res.status) {
      setUser(res.data)
      setIsparticipant(res.data.role === 'participant' ? true : false)
    }
  }

  let callAPI2 = async () => {
    let res = await getSetting()

    if (res.status) {
      res.data.map((entry, index) => {
        if (entry.name === 'withdrawal') setwithdrwal(entry.value)
      })
    } else {
      setIsOn(null)
      enqueueSnackbar('unable to fetch setting', {
        variant: 'error',
        action: key => (
          <button
            className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key)
            }}
          >
            X
          </button>
        )
      })
    }
  }

  let callAPI3 = async () => {
    let formdataa = {}
    let res = await WaitlistPlayersAPI(formdataa)
    if (res.data.totalRecords == 1) {
      setWaitingPlayer(true)
    }
  }

  let callAPI4 = async () => {
    let res = await getPlayerSportsLatest()

    if (res.data.status) {
      const availableSports = res.data.data.sports.filter(
        sport => !res.data.data.withdrawan_sports.includes(sport)
      )
      setSports(availableSports)
    }
  }

  return (
    <>
      <CButton
        className='text-white'
        style={{ background: profile_btn_color }}
        onClick={() => setVisible(!visible)}
      >
        Edit Profile
      </CButton>
      <CForm>
        <CModal
          alignment='center'
          visible={visible}
          onClose={() => {
            setVisible(false)

            setDisableButton(true)
          }}
          className={Zindex ? 'edit_profile_modal' : 'default_modal'}
          aria-labelledby='VerticallyCenteredExample'
          backdrop="static"
        >
          <CModalHeader>
            <CModalTitle>Edit Profile</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div className='d-flex justify-content-center align-items-end'>
              <div>
                <img
                  src={profileImage}
                  alt='Updatable'
                  className='img-fluid'
                  style={{
                    width: '135px',
                    height: '135px',
                    cursor: 'pointer',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                  onClick={handleImageClick}
                />
                <input
                  type='file'
                  accept='image/png, image/jpeg, image/jpg, image/gif, image/webp'
                  onChange={handleImageChange}
                  ref={fileInputRef}
                  style={{ display: 'none' }}
                />
              </div>
              <div>
                {user_details.profile_image == null ||
                user_details.profile_image.trim() == '' ||
                profileImage.includes('blank_user.png') ? (
                  <label className='remove_profile_btn bi bi-pencil'>
                    <input
                      type='file'
                      accept='image/png, image/jpeg, image/jpg, image/gif, image/webp'
                      onChange={handleImageChange}
                      ref={fileInputRef}
                      style={{ display: 'none' }} // Hide the input
                    />
                    {/* Button-like text/icon */}
                  </label>
                ) : (
                  <button
                    className='remove_profile_btn bi bi-x-circle'
                    onClick={() => setPhotovisible(true)}
                  ></button>
                )}
              </div>
            </div>

            <CFormInput
              className='mb-3'
              type='text'
              id='username'
              label='Username'
              placeholder='Username'
              required
              name='username'
              value={formData.username}
              onChange={handleChange}
              isInvalid={!!usernameError || !!formErrors.username}
            />
            {usernameError && <p className='text-danger'>{usernameError}</p>}
            {formErrors.username && (
              <p className='text-danger'>{formErrors.username}</p>
            )}

            <CFormInput
              className='mb-3'
              type='text'
              id='fname'
              label='First Name'
              placeholder='First Name'
              required
              name='fname'
              value={formData.fname}
              onChange={handleChange}
              isInvalid={!!formErrors.fname}
            />
            {formErrors.fname && (
              <p className='text-danger'>{formErrors.fname}</p>
            )}

            <CFormInput
              className='mb-3'
              type='text'
              id='lname'
              label='Last Name'
              placeholder='Last Name'
              required
              name='lname'
              value={formData.lname}
              onChange={handleChange}
              isInvalid={!!formErrors.lname}
            />
            {formErrors.lname && (
              <p className='text-danger'>{formErrors.lname}</p>
            )}
            <label> Action</label>
            <div className='d-flex align-items-center'>
              <div
                className='text-center'
                onClick={() => setVisible(true)}
                visble={visible}
              >
                <ChangePassword
                  onModalOpen={() => setZindex(true)}
                  OnModalClose={() => setZindex(false)}
                >
                  {' '}
                </ChangePassword>
              </div>
              <div>
                {isparticipant && withdrawal === 'true' && Sports.length > 0 ? (
                  <Withdrwal
                    onModalOpen={() => setZindex(true)}
                    OnModalClose={() => setZindex(false)}
                    className='ms-1'
                  >
                    {' '}
                  </Withdrwal>
                ) : null}
              </div>
            </div>
            {/* 
            {user_details.role === 'participant' && (
              <CFormInput
                className="mb-3"
                type="text"
                id="corporate_email"
                label="Team"
                placeholder="Corporate Email"
                required
                name="corporate_email"
                value={formData.corporate_email}
                readOnly
              />
            )}

            <CFormInput
              className="mb-3"
              type="text"
              id="email"
              label="Email"
              placeholder="Email"
              required
              name="email"
              value={formData.email}
              readOnly
            /> */}
          </CModalBody>
          <CModalFooter className='d-block'>
            <div className='d-flex justify-content-between align-items-center float-end'>
              <div className='d-flex  align-items-center'>
                <CButton
                  style={{ background: '#6b7785' }}
                  className='btn-secondary edit_profmodal_all_btn '
                  onClick={() => setVisible(!visible)}
                >
                  Close
                </CButton>
                <CButton
                  type='submit'
                  className='edit_profmodal_all_btn ms-1'
                  onClick={e => handleSubmit(e)}
                  color='primary'
                  disabled={disableButton}
                >
                  Save changes
                </CButton>
              </div>
            </div>
          </CModalFooter>
        </CModal>
        {/* Remove photo modal  */}
        {/* Remove photo modal */}
        <CModal
          visible={Photovisible} // Use 'visible' prop to control the modal
          onClose={() => setPhotovisible(false)}
          aria-labelledby='LiveDemoExampleLabel'
        >
          <CModalHeader>
            <CModalTitle id='LiveDemoExampleLabel'>
              Remove Profile Photo
            </CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p>Are you sure you want to remove your profile photo?</p>
          </CModalBody>
          <CModalFooter>
            <CButton color='secondary' onClick={() => setPhotovisible(false)}>
              Cancel
            </CButton>
            <CButton color='primary' onClick={handleRemoveModal}>
              Remove
            </CButton>
          </CModalFooter>
        </CModal>
      </CForm>
    </>
  )
}

export default Profileupdate
